<app-file-preview
  class="m-t-8"
  [files]="filesWithStates()"
  (thumbnailClicked)="onThumbnailClicked($event)"
  [showLinkFileIcon]="true"
  (fileLinked)="onFileLinkedChange($event)"></app-file-preview>

@if (openFileViewer && selectedFile) {
  <app-file-viewer
    [navDisplayText]="navDisplayTextForFileViewer"
    [readOnly]="readOnly"
    [hideActions]="true"
    [showLinkFileIcon]="true"
    [linkFileMessage]="linkFileMessage"
    [openFileViewer]="openFileViewer"
    [file]="selectedFile"
    [disableNext]="disableNext"
    [disablePrevious]="disablePrevious"
    (fileViewerClosed)="onFileViewerClosed()"
    (nextClicked)="onNextClicked()"
    (previousClicked)="onPreviousClicked()"
    (fileLinked)="onFileLinkedChange($event)"></app-file-viewer>
}
